import { NgModule } from '@angular/core';
import {RouterModule, Routes} from "@angular/router";

import {ProjectsComponent} from "./projects.component";
import {DetailsComponent} from "./details/details.component";
import {ProjectService} from "../services/project.service";
import {TimeService} from "../services/time.service";
import {FormatService} from "../services/format.service";
import {FreelancersService} from "../services/freelancers.service";

const routes: Routes = [
    { path: '',      component: ProjectsComponent },
    { path: ':id',      component: DetailsComponent },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [ProjectService, TimeService, FormatService, FreelancersService]
})
export class ProjectsRoutingModule { }



// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/projects-routing.module.ts